import React from 'react';
import cn from 'classnames';

import { Icon } from 'components/shared/Icon';
import { Input } from 'components/shared/Input';
import { Button } from 'components/shared/Button';

import styles from './TableToolbar.module.scss';

const TableToolbar = ({
  className,
  searchExpanded,
  onSearchChange,
  onSearchBlur,
  onSearchBtnClick,
  searchFieldClassName,
}: {
  className?: string;
  searchExpanded: any;
  onSearchChange: any;
  onSearchBlur: any;
  onSearchBtnClick: any;
  searchFieldClassName?: string;
}) => (
  <div className={cn(styles.toolbar, className)}>
    <div className={styles.searchAction}>
      {!searchExpanded && (
        <Button
          className={styles.searchBtn}
          variant="ghost"
          mode="icon"
          size="md"
          iconName="search"
          onClick={onSearchBtnClick}
        />
      )}
      {searchExpanded && (
        <Input
          className={styles.searchInput}
          fieldClassName={cn(styles.searchField, searchFieldClassName)}
          autoFocus
          endAdornment={<Icon name="search" className={styles.searchIcon} />}
          onChange={onSearchChange}
          onBlur={onSearchBlur}
        />
      )}
    </div>
  </div>
);

export default React.memo(TableToolbar) as any;
